import {SizeSelection_Size} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/size_selection.types';
import {useTranslation} from '@aboutyou/i18n';
import {Button} from '@aboutyou/ui-components';
import React, {useMemo} from 'react';

interface AddToBasketButtonProps {
  isProcessing: boolean;
  isInBasket: (sizeId?: number | undefined) => boolean;
  size?: SizeSelection_Size;
  onClick: VoidFunction;
  isOneSize?: boolean;
}

export const AddToBasketQuickViewButton: React.FC<AddToBasketButtonProps> = ({
  isProcessing,
  isInBasket,
  size,
  onClick,
  isOneSize,
}) => {
  const {t} = useTranslation();
  const defaultCta = t(`Select your size`);
  const addToBasket = t('Add to basket');
  const alreadyInBasket = t('Already in basket');

  const label = useMemo(() => {
    if (isInBasket(size?.sizeId)) {
      return alreadyInBasket;
    }

    return size?.sizeId ? addToBasket : defaultCta;
  }, [isInBasket, size, isOneSize, defaultCta, addToBasket, alreadyInBasket]);

  return (
    <Button
      isLoading={isProcessing}
      onClick={onClick}
      data-testid="addToBasketButton"
    >
      {label}
    </Button>
  );
};
